import { Role } from "../Permission";
import { ISystemProxy } from "./ISystem";

interface IUser {
  uuid: string;
  email: string;
  name: string;
  systems_count?: number;
  country?: string;
  phoneNumber?: string;
  roles: Role[];
  systems: ISystemProxy[];

  created_at?: string;
  updated_at?: string;
}

export { IUser }